'use strict';

module.exports = function(Department, dialog, forms, $state, teams, items, toast, $translate) {
    var _this = this;
    this.items = items;
    this.form = forms.filter(function(form) {
        return form.id === $state.params.formId;
    })[0];


    _this.teams = teams.map(function(team) {
        var isSub = team.subscribedTo.filter(function(teamForm) {
            return teamForm.id === $state.params.formId;
        });

        if (isSub.length) {
            team.status = true;
        } else {
            team.status = false;
        }
        return team;
    });

    this.editForm = function() {
        $state.go('dashboard.departments.department.forms.form.builder');
    };

    this.subscriptionHandler = function(itemId, status) {
        if (status) {
            Department.addTeam({
                    departmentId: $state.params.departmentId,
                    formId: $state.params.formId,
                    teamId: itemId
                }, {})
                .$promise
                .then(function() {
                    toast.success($translate.instant('DASHBOARD.DASH_FORM.TEAMS.ADD_TEAM'));
                    _this.form.teams.push({
                        id: itemId
                    });

                })
                .catch(function(error) {
                    toast.error($translate.instant('DASHBOARD.DASH_FORM.TEAMS.ADD_TEAM_ERR'));
                    console.log(error);
                });
        } else {
            Department.removeTeam({
                    departmentId: $state.params.departmentId,
                    formId: $state.params.formId,
                    teamId: itemId
                }, {})
                .$promise
                .then(function() {
                    toast.success($translate.instant('DASHBOARD.DASH_FORM.TEAMS.REMOVE_TEAM'));
                    _this.form.teams = _this.form.teams.filter(function(team) {
                        return team.id !== itemId;
                    });
                    return;

                })
                .catch(function(error) {
                    toast.error($translate.instant('DASHBOARD.DASH_FORM.TEAMS.REMOVE_TEAM_ERR'));
                    console.log(error);
                });
        }
    };
};
